import { format } from 'date-fns'
import React, { ReactNode, useEffect, useState } from 'react'
import ModalComponent from '..'
import { formatCurrency } from '../../../helpers'
import { SingleVoucher } from '../../../redux-toolkits/voucher/voucher.type'
import { Status } from '../../cards/statusTag'

export const ViewVoucherModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  voucher: SingleVoucher
}> = ({ open, setOpen, onCloseCallback = () => {}, voucher }) => {
  const [details, setDetails] = useState<
    {
      title: string
      element: ReactNode
    }[]
  >([])

  useEffect(() => {
    setDetails([
      {
        title: 'Value',
        element: formatCurrency(voucher.value, {
          decimalPlaces: 2,
          currency: 'NGN',
        }),
      },
      {
        title: 'Sender',
        element: voucher?.metadata?.senderName ?? 'N/A',
      },
      {
        title: 'Sender Email',
        element: voucher?.metadata?.senderEmail ?? 'N/A',
      },
      {
        title: 'Recipient',
        element: voucher?.metadata?.recipientName ?? 'N/A',
      },
      {
        title: 'Recipient Email',
        element: voucher?.metadata?.emailVoucherSentTo ?? 'N/A',
      },
      {
        title: 'Creation date',
        element: format(new Date(voucher?.createdAt), 'dd/MM/yyyy h:mma'),
      },
      {
        title: 'Usage status',
        element: voucher?.isActive ? (
          <Status
            key={`${voucher._id}-status`}
            text={voucher.used ? 'Redeemed' : 'Unused'}
            type={voucher.used ? 'success' : 'warn'}
          />
        ) : (
          <Status
            key={`${voucher._id}-status`}
            text={'Deactivated'}
            type={'fail'}
          />
        ),
      },
      {
        title: 'Redemption date',
        element: voucher?.usedAt
          ? format(new Date(voucher.usedAt), 'dd/MM/yyyy h:mma')
          : '-',
      },
    ])
  }, [voucher])

  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        onCloseCallback()
      }}
      title={`Voucher #${voucher.code}`}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="flex flex-col w-full max-w-[800px]">
        {details.map((detail, idx) => {
          const key = `${detail.title}-${idx}`

          return (
            <div
              className="
                py-4
                first:pt-0 last:pb-0
                border-b last:border-b-0
                flex gap-4
                items-center justify-between
                "
              key={key}
            >
              <span className="text-sec-black">{detail.title}</span>
              <span className="text-black font-medium">{detail.element}</span>
            </div>
          )
        })}
      </div>
    </ModalComponent>
  )
}
